"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeatureCollection = exports.getFeatures = exports.getGeometries = exports.parse = void 0;
const types_1 = require("./types");
const utils = __importStar(require("./utils"));
function parse(data) {
    if (Array.isArray(data)) {
        return getFeatureCollection(data.map((item) => parse(item)));
    }
    if (data.type === types_1.GEOMETRY_COLLECTION) {
        return parse(data.geometries);
    }
    const feature = utils.toFeature(utils.toGeometry(data.type, data.coordinates), data.properties);
    return getFeatureCollection(feature);
}
exports.parse = parse;
function getGeometries(geom) {
    return getFeatures(geom).map((feature) => feature.geometry);
}
exports.getGeometries = getGeometries;
function getFeatures(geom) {
    if (Array.isArray(geom)) {
        return geom
            .map((g) => getFeatures(g))
            .reduce((acc, item) => [...acc, ...item], []);
    }
    else if (geom.type === types_1.GEOMETRY_COLLECTION) {
        return getFeatures(geom.geometries);
    }
    else if (geom.type === types_1.FEATURE_COLLECTION_TYPE) {
        return geom.features;
    }
    else if (geom.type === types_1.FEATURE_TYPE) {
        return [geom];
    }
    else if (Object.values(types_1.GeometryType).includes(geom.type)) {
        return [utils.toFeature(geom)];
    }
    return [];
}
exports.getFeatures = getFeatures;
function getFeatureCollection(geom) {
    return utils.toFeatureCollection(getFeatures(geom));
}
exports.getFeatureCollection = getFeatureCollection;
//# sourceMappingURL=functions.js.map